import { useWasEnabled } from './useWasEnabled';
import { OnboardingPhase2HookProps } from '../types';

import { useClusterQuery } from '@cast/shared-cluster-context-data-access';

export const useWasCredentialsAssigned = ({
  clusterId,
  onSuccess,
  onError,
  enabled,
}: OnboardingPhase2HookProps): boolean => {
  const { cluster: _cluster, error } = useClusterQuery(
    clusterId,
    enabled ? 10_000 : false
  );

  const isManaged = Boolean(_cluster?.credentialsId);

  useWasEnabled({
    currentState: isManaged,
    onSuccess: onSuccess,
    onError: onError,
    error,
    enabled,
  });

  return isManaged;
};
